import React from 'react';
import { Helmet } from 'react-helmet-async';
import { AppHeader } from '../components/AppHeader';
import { AppFooter } from '../components/AppFooter';
import { useScreenInit } from '../useScreenInit';
import { Users } from 'lucide-react';
import { Input } from '../components/Input';
import { Textarea } from '../components/Textarea';
import { Label } from '../components/Label';
import { Checkbox } from '../components/Checkbox';
import { Button } from '../components/Button';
export function PartnerFacilitator() {
  useScreenInit('PartnerFacilitator');
  return <div className="min-h-screen bg-slate-50 flex flex-col" data-id="element-1100">
      <Helmet data-id="element-1101">
        <title data-id="element-1102">Facilitator Partner Sign-up | Affordable Medical Tourism</title>
        <meta name="description" content="Join our network of expert local facilitators. Partner with Kosansh Solutions Inc to provide logistics and support for international patients." data-id="element-1103" />
      </Helmet>

      <AppHeader data-id="element-1104" />

      <main className="flex-1 w-full max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-20" data-id="element-1105">
        <div className="text-center mb-12" data-id="element-1106">
          <h1 className="text-4xl font-bold tracking-tight text-slate-900 sm:text-5xl mb-6" data-id="element-1107">
            Facilitator Partner Sign-up
          </h1>
          <p className="text-lg text-slate-600 leading-relaxed" data-id="element-1108">
            We partner with dedicated local logistics experts to ensure patients
            have a seamless experience, from airport shuttles to specialized
            meal plans.
          </p>
        </div>

        <div className="bg-white rounded-2xl shadow-xl border border-slate-200 overflow-hidden flex flex-col" data-id="element-1109">
          <div className="p-8 bg-blue-600 text-white flex items-center gap-4" data-id="element-1110">
            <Users className="w-8 h-8 text-blue-200" data-id="element-1111" />
            <div data-id="element-1112">
              <h2 className="text-2xl font-semibold" data-id="element-1113">
                Facilitator Application
              </h2>
              <p className="text-blue-100 text-sm mt-1" data-id="element-1114">
                For Local Logistics Partners
              </p>
            </div>
          </div>
          <div className="p-8 flex-1" data-id="element-1115">
            <form className="space-y-8" onSubmit={e => e.preventDefault()} data-id="element-1116">
              <div className="space-y-2" data-id="element-1117">
                <Label htmlFor="companyName" data-id="element-1118">Company Name</Label>
                <Input id="companyName" placeholder="e.g. Global Med Travel" data-id="element-1119" />
              </div>
              <div className="space-y-2" data-id="element-1120">
                <Label htmlFor="operatingRegion" data-id="element-1121">
                  Operating Region/Country
                </Label>
                <Input id="operatingRegion" placeholder="e.g. Thailand" data-id="element-1122" />
              </div>

              <div className="space-y-4" data-id="element-1123">
                <Label data-id="element-1124">Services Offered (Select all that apply)</Label>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-1125">
                  <div className="flex items-center space-x-2" data-id="element-1126">
                    <Checkbox id="service-visa" data-id="element-1127" />
                    <label htmlFor="service-visa" className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70" data-id="element-1128">
                      Visa Assistance
                    </label>
                  </div>
                  <div className="flex items-center space-x-2" data-id="element-1129">
                    <Checkbox id="service-airport" data-id="element-1130" />
                    <label htmlFor="service-airport" className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70" data-id="element-1131">
                      Airport Shuttle
                    </label>
                  </div>
                  <div className="flex items-center space-x-2" data-id="element-1132">
                    <Checkbox id="service-travel" data-id="element-1133" />
                    <label htmlFor="service-travel" className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70" data-id="element-1134">
                      Travel Planning
                    </label>
                  </div>
                  <div className="flex items-center space-x-2" data-id="element-1135">
                    <Checkbox id="service-insurance" data-id="element-1136" />
                    <label htmlFor="service-insurance" className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70" data-id="element-1137">
                      Insurance Support
                    </label>
                  </div>
                  <div className="flex items-center space-x-2" data-id="element-1138">
                    <Checkbox id="service-rental" data-id="element-1139" />
                    <label htmlFor="service-rental" className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70" data-id="element-1140">
                      Short-term Rental
                    </label>
                  </div>
                  <div className="flex items-center space-x-2" data-id="element-1141">
                    <Checkbox id="service-meals" data-id="element-1142" />
                    <label htmlFor="service-meals" className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70" data-id="element-1143">
                      Meals (Veg, Jain, Halal, etc.)
                    </label>
                  </div>
                </div>
              </div>

              <div className="space-y-2" data-id="element-1144">
                <Label htmlFor="facilitatorContact" data-id="element-1145">Contact Person Name</Label>
                <Input id="facilitatorContact" placeholder="Full Name" data-id="element-1146" />
              </div>
              <div className="space-y-2" data-id="element-1147">
                <Label htmlFor="facilitatorPhone" data-id="element-1148">Phone Number</Label>
                <Input id="facilitatorPhone" type="tel" placeholder="+1 (555) 000-0000" data-id="element-1149" />
              </div>
              <div className="space-y-2" data-id="element-1150">
                <Label htmlFor="facilitatorMessage" data-id="element-1151">Message</Label>
                <Textarea id="facilitatorMessage" placeholder="Describe your experience with medical tourists and specific meal types you can accommodate..." className="min-h-[100px]" data-id="element-1152" />
              </div>
              <Button type="submit" className="w-full" size="lg" data-id="element-1153">
                Submit Application
              </Button>
            </form>
          </div>
        </div>
      </main>

      <AppFooter data-id="element-1154" />
    </div>;
}